import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import StatusUpdateModalUI from './StatusUpdateModalUI.js'

class StatusUpdateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      status: this.props.loan.status,
      statusError: null,
      statusList: [],
      subStatus: this.props.loan.subStatus,
      subStatusError: null,
      subStatusList: [],
      reason: this.props.loan.closingReason,
      reasonError: null,
    }
  }

  render() {
    return (
      <StatusUpdateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.onCancelClick}
        // form fields
        status={this.state.status}
        onStatusChange={this.onStatusChange}
        statusError={this.state.statusError}
        setStatusError={(error) => { this.setState({ statusError: error }) }}
        statusList={this.state.statusList}
        subStatus={this.state.subStatus}
        onSubStatusChange={this.onSubStatusChange}
        subStatusError={this.state.subStatusError}
        setSubStatusError={(error) => { this.setState({ subStatusError: error }) }}
        subStatusList={this.state.subStatusList}
        reason={this.state.reason}
        onReasonChange={this.onReasonChange}
        reasonError={this.state.reasonError}
        setReasonError={(error) => { this.setState({ reasonError: error }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
    let statusList = [
      { key: 'requested', value: 'requested' },
      { key: 'term_sheet', value: 'term_sheet' },
      { key: 'sanctioned', value: 'sanctioned' },
      { key: 'disbursed', value: 'disbursed' },
      { key: 'closed', value: 'closed' },
    ]
    let subStatusList = this.getSubStatusList(this.props.loan.status)
    this.setState({ statusList: statusList, subStatusList: subStatusList })
  }

  getSubStatusList(status) {
    let subStatusList = []
    switch (status) {
      case 'requested':
        subStatusList = [
          { key: 'draft', value: 'draft' },
          { key: 'appl_fee_paid', value: 'appl_fee_paid' },
          { key: 'fin_docs_collected', value: 'fin_docs_collected' },
          { key: 'project_added', value: 'project_added' },
          { key: 'references_added', value: 'references_added' },
          { key: 'draft_bills_added', value: 'draft_bills_added' },
          { key: 'term_sheet_requested', value: 'term_sheet_requested' }
        ]
        break;
      case 'term_sheet':
        subStatusList = [
          { key: 'term_sheet_review', value: 'term_sheet_review' },
          { key: 'term_sheet_offered', value: 'term_sheet_offered' },
          { key: 'processing_fee_1_paid', value: 'processing_fee_1_paid' },
          // { key: 'term_sheet_accepted', value: 'term_sheet_accepted' },
          { key: 'sanction_requested', value: 'sanction_requested' },
        ]
        break;
      case 'sanctioned':
        subStatusList = [
          { key: 'sanction_accepted', value: 'sanction_accepted' },
          { key: 'bills_added', value: 'bills_added' },
          { key: 'documents_signed', value: 'documents_signed' },
          { key: 'documents_upload', value: 'documents_upload' },
          { key: 'documents_uploaded', value: 'documents_uploaded' },
          { key: 'processing_fee_2_paid', value: 'processing_fee_2_paid' },
          { key: 'disbursement_request', value: 'disbursement_request' },
        ]
        break;
      case 'disbursed':
        subStatusList = [
          { key: 'good_standing', value: 'good_standing' },
          { key: 'delinquent', value: 'delinquent' },
        ]
        break;
      case 'closed':
        subStatusList = [
          { key: 'request_rejected', value: 'request_rejected' },
          { key: 'term_sheet_expired', value: 'term_sheet_expired' },
          { key: 'sanction_expired', value: 'sanction_expired' },
          // { key: 'prepaid', value: 'prepaid' },
          { key: 'repaid', value: 'repaid' },
          // { key: 'received', value: 'received' },
          { key: 'defaulted', value: 'defaulted' },
        ]
        break;
      default:
    }
    return subStatusList
  }

  onStatusChange = (event) => {
    let subStatusList = this.getSubStatusList(event.target.value)
    this.setState({ status: event.target.value, subStatus: subStatusList[0].key, subStatusList: subStatusList })
  }

  onSubStatusChange = (event) => {
    this.setState({ subStatus: event.target.value })
  }

  onReasonChange = (event) => {
    this.setState({ reason: event.target.value })
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/subStatus`,
      this.onSubmitCallback, {
      subStatus: this.state.subStatus,
      reason: this.state.reason,
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
        this.props.onRefreshClick()
      }, 1000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }

  onCancelClick = () => {
    let subStatusList = this.getSubStatusList(this.props.loan.status)
    this.setState({
      successMsg: null, errorList: null, reasonError: '',
      status: this.props.loan.status,
      subStatus: this.props.loan.subStatus,
      subStatusList: subStatusList,
    })
    this.props.onCancelClick()
  }
}

export default withRouter(StatusUpdateModalSF)
